import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_2 = { class: "supplier-option" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Submit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.name,
    footer: null,
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        layout: "vertical",
        ref: "formRef",
        model: _ctx.form,
        id: "myForm",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('save', _ctx.form)), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "Business Unit" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                id: "business_unit_id",
                filterOption: "filterOption",
                optionFilterProp: "children",
                "show-search": "",
                onChange: _ctx.handleSiteChange,
                value: _ctx.form.org_id,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.org_id) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.org_id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onChange", "value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Vendor",
            name: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.form.vendor_id,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.vendor_id) = $event)),
                id: "vendor_id",
                style: {"width":"100%"},
                "show-search": "",
                disabled: _ctx.disabled_vendor,
                onSearch: _ctx.handleSearchVendor,
                "filter-option": false,
                "not-found-content": _ctx.vendor_fetching ? undefined : null
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "all" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vendors, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, [
                (_ctx.vendor_fetching)
                  ? {
                      name: "notFoundContent",
                      fn: _withCtx(() => [
                        _createVNode(_component_a_spin, { size: "small" })
                      ])
                    }
                  : undefined
              ]), 1032, ["value", "disabled", "onSearch", "not-found-content"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 12,
                style: { paddingRight: '16px' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Start Date",
                    name: "start_date",
                    rules: [ { required: true, message: 'Please select a start date' } ],
                    inline: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "date",
                        value: _ctx.form.start_date,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.start_date) = $event)),
                        id: "start_date"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 12,
                style: { paddingLeft: '16px' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "End Date",
                    name: "end_date",
                    rules: [ { required: true, message: 'Please select an end date' } ],
                    inline: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "date",
                        value: _ctx.form.end_date,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.end_date) = $event)),
                        id: "end_date"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { style: {"text-align":"right","margin-top":"40px","margin-bottom":"0"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    key: "back",
                    onClick: _ctx.cancelDownload
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_button, {
                    key: "submit",
                    type: "primary",
                    htmlType: "submit",
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}